!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.contentful = t() : e.contentful = t();
}(window, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) {
        t.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 34);
  }([function (e, t, n) {
    var r = n(51);

    e.exports = function (e) {
      return r(e, 5);
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return "[object Array]" === u.call(e);
    }

    function o(e) {
      return null !== e && "object" == typeof e;
    }

    function i(e) {
      return "[object Function]" === u.call(e);
    }

    function a(e, t) {
      if (null != e) if ("object" != typeof e && (e = [e]), r(e)) for (var n = 0, o = e.length; n < o; n++) {
        t.call(null, e[n], n, e);
      } else for (var i in e) {
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
      }
    }

    var c = n(11),
        s = n(36),
        u = Object.prototype.toString;
    e.exports = {
      isArray: r,
      isArrayBuffer: function isArrayBuffer(e) {
        return "[object ArrayBuffer]" === u.call(e);
      },
      isBuffer: s,
      isFormData: function isFormData(e) {
        return "undefined" != typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(e) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
      },
      isString: function isString(e) {
        return "string" == typeof e;
      },
      isNumber: function isNumber(e) {
        return "number" == typeof e;
      },
      isObject: o,
      isUndefined: function isUndefined(e) {
        return void 0 === e;
      },
      isDate: function isDate(e) {
        return "[object Date]" === u.call(e);
      },
      isFile: function isFile(e) {
        return "[object File]" === u.call(e);
      },
      isBlob: function isBlob(e) {
        return "[object Blob]" === u.call(e);
      },
      isFunction: i,
      isStream: function isStream(e) {
        return o(e) && i(e.pipe);
      },
      isURLSearchParams: function isURLSearchParams(e) {
        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: a,
      merge: function e() {
        function t(t, r) {
          n[r] = "object" == typeof n[r] && "object" == typeof t ? e(n[r], t) : t;
        }

        for (var n = {}, r = 0, o = arguments.length; r < o; r++) {
          a(arguments[r], t);
        }

        return n;
      },
      deepMerge: function e() {
        function t(t, r) {
          n[r] = "object" == typeof n[r] && "object" == typeof t ? e(n[r], t) : "object" == typeof t ? e({}, t) : t;
        }

        for (var n = {}, r = 0, o = arguments.length; r < o; r++) {
          a(arguments[r], t);
        }

        return n;
      },
      extend: function extend(e, t, n) {
        return a(t, function (t, r) {
          e[r] = n && "function" == typeof t ? c(t, n) : t;
        }), e;
      },
      trim: function trim(e) {
        return e.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      function r() {
        return void 0 !== e && !e.browser;
      }

      function o() {
        return e.versions.node ? "v".concat(e.versions.node) : e.version;
      }

      n.d(t, "b", function () {
        return r;
      }), n.d(t, "a", function () {
        return o;
      });
    }).call(this, n(15));
  }, function (e, t, n) {
    function r(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    var o = n(53),
        i = n(54),
        a = n(55),
        c = n(56),
        s = n(57);
    r.prototype.clear = o, r.prototype.delete = i, r.prototype.get = a, r.prototype.has = c, r.prototype.set = s, e.exports = r;
  }, function (e, t, n) {
    var r = n(20);

    e.exports = function (e, t) {
      for (var n = e.length; n--;) {
        if (r(e[n][0], t)) return n;
      }

      return -1;
    };
  }, function (e, t, n) {
    var r = n(8)(Object, "create");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(74);

    e.exports = function (e, t) {
      var n = e.__data__;
      return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
  }, function (e, t, n) {
    var r = n(23),
        o = n(24);

    e.exports = function (e, t, n, i) {
      var a = !n;
      n || (n = {});

      for (var c = -1, s = t.length; ++c < s;) {
        var u = t[c],
            f = i ? i(n[u], e[u], u, n, e) : void 0;
        void 0 === f && (f = e[u]), a ? o(n, u, f) : r(n, u, f);
      }

      return n;
    };
  }, function (e) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e) {
    e.exports = function (e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function () {}, function (e) {
    "use strict";

    e.exports = function (e, t) {
      return function () {
        for (var n = Array(arguments.length), r = 0; r < n.length; r++) {
          n[r] = arguments[r];
        }

        return e.apply(t, n);
      };
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return encodeURIComponent(e).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    var o = n(1);

    e.exports = function (e, t, n) {
      if (!t) return e;
      var i;
      if (n) i = n(t);else if (o.isURLSearchParams(t)) i = t.toString();else {
        var a = [];
        o.forEach(t, function (e, t) {
          null == e || (o.isArray(e) ? t += "[]" : e = [e], o.forEach(e, function (e) {
            o.isDate(e) ? e = e.toISOString() : o.isObject(e) && (e = JSON.stringify(e)), a.push(r(t) + "=" + r(e));
          }));
        }), i = a.join("&");
      }
      return i && (e += (-1 === e.indexOf("?") ? "?" : "&") + i), e;
    };
  }, function (e) {
    "use strict";

    e.exports = function (e) {
      return !(!e || !e.__CANCEL__);
    };
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function r(e, t) {
        !o.isUndefined(e) && o.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
      }

      var o = n(1),
          i = n(41),
          a = {
        "Content-Type": "application/x-www-form-urlencoded"
      },
          c = {
        adapter: function () {
          var e;
          return void 0 !== t && "[object process]" === Object.prototype.toString.call(t) ? e = n(16) : "undefined" != typeof XMLHttpRequest && (e = n(16)), e;
        }(),
        transformRequest: [function (e, t) {
          return i(t, "Accept"), i(t, "Content-Type"), o.isFormData(e) || o.isArrayBuffer(e) || o.isBuffer(e) || o.isStream(e) || o.isFile(e) || o.isBlob(e) ? e : o.isArrayBufferView(e) ? e.buffer : o.isURLSearchParams(e) ? (r(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : o.isObject(e) ? (r(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
        }],
        transformResponse: [function (e) {
          if ("string" == typeof e) try {
            e = JSON.parse(e);
          } catch (e) {}
          return e;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(e) {
          return 200 <= e && 300 > e;
        },
        headers: {
          common: {
            Accept: "application/json, text/plain, */*"
          }
        }
      };
      o.forEach(["delete", "get", "head"], function (e) {
        c.headers[e] = {};
      }), o.forEach(["post", "put", "patch"], function (e) {
        c.headers[e] = o.merge(a);
      }), e.exports = c;
    }).call(this, n(15));
  }, function (e) {
    function t() {
      throw new Error("setTimeout has not been defined");
    }

    function n() {
      throw new Error("clearTimeout has not been defined");
    }

    function r(e) {
      if (s === setTimeout) return setTimeout(e, 0);
      if ((s === t || !s) && setTimeout) return s = setTimeout, setTimeout(e, 0);

      try {
        return s(e, 0);
      } catch (t) {
        try {
          return s.call(null, e, 0);
        } catch (t) {
          return s.call(this, e, 0);
        }
      }
    }

    function o() {
      d && l && (d = !1, l.length ? p = l.concat(p) : h = -1, p.length && i());
    }

    function i() {
      if (!d) {
        var e = r(o);
        d = !0;

        for (var t = p.length; t;) {
          for (l = p, p = []; ++h < t;) {
            l && l[h].run();
          }

          h = -1, t = p.length;
        }

        l = null, d = !1, function (e) {
          if (u === clearTimeout) return clearTimeout(e);
          if ((u === n || !u) && clearTimeout) return u = clearTimeout, clearTimeout(e);

          try {
            u(e);
          } catch (t) {
            try {
              return u.call(null, e);
            } catch (t) {
              return u.call(this, e);
            }
          }
        }(e);
      }
    }

    function a(e, t) {
      this.fun = e, this.array = t;
    }

    function c() {}

    var s,
        u,
        f = e.exports = {};
    !function () {
      try {
        s = "function" == typeof setTimeout ? setTimeout : t;
      } catch (e) {
        s = t;
      }

      try {
        u = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (e) {
        u = n;
      }
    }();
    var l,
        p = [],
        d = !1,
        h = -1;
    f.nextTick = function (e) {
      var t = Array(arguments.length - 1);
      if (1 < arguments.length) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      p.push(new a(e, t)), 1 !== p.length || d || r(i);
    }, a.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, f.title = "browser", f.browser = !0, f.env = {}, f.argv = [], f.version = "", f.versions = {}, f.on = c, f.addListener = c, f.once = c, f.off = c, f.removeListener = c, f.removeAllListeners = c, f.emit = c, f.prependListener = c, f.prependOnceListener = c, f.listeners = function () {
      return [];
    }, f.binding = function () {
      throw new Error("process.binding is not supported");
    }, f.cwd = function () {
      return "/";
    }, f.chdir = function () {
      throw new Error("process.chdir is not supported");
    }, f.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1),
        o = n(42),
        i = n(12),
        a = n(44),
        c = n(45),
        s = n(17);

    e.exports = function (e) {
      return new Promise(function (t, u) {
        var f = e.data,
            l = e.headers;
        r.isFormData(f) && delete l["Content-Type"];
        var p = new XMLHttpRequest();

        if (e.auth) {
          var d = e.auth.username || "",
              h = e.auth.password || "";
          l.Authorization = "Basic " + btoa(d + ":" + h);
        }

        if (p.open(e.method.toUpperCase(), i(e.url, e.params, e.paramsSerializer), !0), p.timeout = e.timeout, p.onreadystatechange = function () {
          if (p && 4 === p.readyState && (0 !== p.status || p.responseURL && 0 === p.responseURL.indexOf("file:"))) {
            var n = "getAllResponseHeaders" in p ? a(p.getAllResponseHeaders()) : null,
                r = {
              data: e.responseType && "text" !== e.responseType ? p.response : p.responseText,
              status: p.status,
              statusText: p.statusText,
              headers: n,
              config: e,
              request: p
            };
            o(t, u, r), p = null;
          }
        }, p.onabort = function () {
          p && (u(s("Request aborted", e, "ECONNABORTED", p)), p = null);
        }, p.onerror = function () {
          u(s("Network Error", e, null, p)), p = null;
        }, p.ontimeout = function () {
          u(s("timeout of " + e.timeout + "ms exceeded", e, "ECONNABORTED", p)), p = null;
        }, r.isStandardBrowserEnv()) {
          var y = n(46),
              v = (e.withCredentials || c(e.url)) && e.xsrfCookieName ? y.read(e.xsrfCookieName) : void 0;
          v && (l[e.xsrfHeaderName] = v);
        }

        if ("setRequestHeader" in p && r.forEach(l, function (e, t) {
          void 0 === f && "content-type" === t.toLowerCase() ? delete l[t] : p.setRequestHeader(t, e);
        }), e.withCredentials && (p.withCredentials = !0), e.responseType) try {
          p.responseType = e.responseType;
        } catch (t) {
          if ("json" !== e.responseType) throw t;
        }
        "function" == typeof e.onDownloadProgress && p.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && p.upload && p.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function (e) {
          p && (p.abort(), u(e), p = null);
        }), void 0 === f && (f = null), p.send(f);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(43);

    e.exports = function (e, t, n, o, i) {
      var a = new Error(e);
      return r(a, t, n, o, i);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1);

    e.exports = function (e, t) {
      t = t || {};
      var n = {};
      return r.forEach(["url", "method", "params", "data"], function (e) {
        void 0 !== t[e] && (n[e] = t[e]);
      }), r.forEach(["headers", "auth", "proxy"], function (o) {
        r.isObject(t[o]) ? n[o] = r.deepMerge(e[o], t[o]) : void 0 === t[o] ? r.isObject(e[o]) ? n[o] = r.deepMerge(e[o]) : void 0 !== e[o] && (n[o] = e[o]) : n[o] = t[o];
      }), r.forEach(["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"], function (r) {
        void 0 === t[r] ? void 0 !== e[r] && (n[r] = e[r]) : n[r] = t[r];
      }), n;
    };
  }, function (e) {
    "use strict";

    function t(e) {
      this.message = e;
    }

    t.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, t.prototype.__CANCEL__ = !0, e.exports = t;
  }, function (e) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, n) {
    var r = n(8)(n(22), "Map");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(63),
        o = "object" == typeof self && self && self.Object === Object && self,
        i = r || o || Function("return this")();
    e.exports = i;
  }, function (e, t, n) {
    var r = n(24),
        o = n(20),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n) {
      var a = e[t];
      i.call(e, t) && o(a, n) && (void 0 !== n || t in e) || r(e, t, n);
    };
  }, function (e, t, n) {
    var r = n(79);

    e.exports = function (e, t, n) {
      "__proto__" == t && r ? r(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    };
  }, function (e, t, n) {
    var r = n(9)(Object.keys, Object);
    e.exports = r;
  }, function (e) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t, n) {
    var r = n(9)(Object.getPrototypeOf, Object);
    e.exports = r;
  }, function (e) {
    "use strict";

    var t = Object.prototype.hasOwnProperty,
        n = Array.isArray,
        r = function () {
      for (var e = [], t = 0; 256 > t; ++t) {
        e.push("%" + ((16 > t ? "0" : "") + t.toString(16)).toUpperCase());
      }

      return e;
    }(),
        o = function o(e) {
      for (; 1 < e.length;) {
        var t = e.pop(),
            r = t.obj[t.prop];

        if (n(r)) {
          for (var o = [], i = 0; i < r.length; ++i) {
            void 0 !== r[i] && o.push(r[i]);
          }

          t.obj[t.prop] = o;
        }
      }
    },
        i = function i(e, t) {
      for (var n = t && t.plainObjects ? Object.create(null) : {}, r = 0; r < e.length; ++r) {
        void 0 !== e[r] && (n[r] = e[r]);
      }

      return n;
    };

    e.exports = {
      arrayToObject: i,
      assign: function assign(e, t) {
        return Object.keys(t).reduce(function (e, n) {
          return e[n] = t[n], e;
        }, e);
      },
      combine: function combine(e, t) {
        return [].concat(e, t);
      },
      compact: function compact(e) {
        for (var t = [{
          obj: {
            o: e
          },
          prop: "o"
        }], n = [], r = 0; r < t.length; ++r) {
          for (var i = t[r], a = i.obj[i.prop], c = Object.keys(a), s = 0; s < c.length; ++s) {
            var u = c[s],
                f = a[u];
            "object" == typeof f && null !== f && -1 === n.indexOf(f) && (t.push({
              obj: a,
              prop: u
            }), n.push(f));
          }
        }

        return o(t), e;
      },
      decode: function decode(e, t, n) {
        var r = e.replace(/\+/g, " ");
        if ("iso-8859-1" === n) return r.replace(/%[0-9a-f]{2}/gi, unescape);

        try {
          return decodeURIComponent(r);
        } catch (t) {
          return r;
        }
      },
      encode: function encode(e, t, n) {
        if (0 === e.length) return e;
        var o = "string" == typeof e ? e : e + "";
        if ("iso-8859-1" === n) return escape(o).replace(/%u[0-9a-f]{4}/gi, function (e) {
          return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
        });

        for (var i, a = "", c = 0; c < o.length; ++c) {
          45 === (i = o.charCodeAt(c)) || 46 === i || 95 === i || 126 === i || 48 <= i && 57 >= i || 65 <= i && 90 >= i || 97 <= i && 122 >= i ? a += o.charAt(c) : 128 > i ? a += r[i] : 2048 > i ? a += r[192 | i >> 6] + r[128 | 63 & i] : 55296 > i || 57344 <= i ? a += r[224 | i >> 12] + r[128 | 63 & i >> 6] + r[128 | 63 & i] : (c += 1, i = 65536 + ((1023 & i) << 10 | 1023 & o.charCodeAt(c)), a += r[240 | i >> 18] + r[128 | 63 & i >> 12] + r[128 | 63 & i >> 6] + r[128 | 63 & i]);
        }

        return a;
      },
      isBuffer: function isBuffer(e) {
        return !(!e || "object" != typeof e || !(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e)));
      },
      isRegExp: function isRegExp(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      merge: function e(r, o, a) {
        if (!o) return r;

        if ("object" != typeof o) {
          if (n(r)) r.push(o);else {
            if (!r || "object" != typeof r) return [r, o];
            (a && (a.plainObjects || a.allowPrototypes) || !t.call(Object.prototype, o)) && (r[o] = !0);
          }
          return r;
        }

        if (!r || "object" != typeof r) return [r].concat(o);
        var c = r;
        return n(r) && !n(o) && (c = i(r, a)), n(r) && n(o) ? (o.forEach(function (n, o) {
          if (t.call(r, o)) {
            var i = r[o];
            i && "object" == typeof i && n && "object" == typeof n ? r[o] = e(i, n, a) : r.push(n);
          } else r[o] = n;
        }), r) : Object.keys(o).reduce(function (n, r) {
          var i = o[r];
          return n[r] = t.call(n, r) ? e(n[r], i, a) : i, n;
        }, c);
      }
    };
  }, function (e) {
    "use strict";

    var t = String.prototype.replace,
        n = /%20/g;
    e.exports = {
      default: "RFC3986",
      formatters: {
        RFC1738: function RFC1738(e) {
          return t.call(e, n, "+");
        },
        RFC3986: function RFC3986(e) {
          return e;
        }
      },
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
  }, function (e, t, n) {
    e.exports = n(35);
  }, function (e, t, n) {
    "use strict";

    var r = n(102),
        o = n(103),
        i = n(29);
    e.exports = {
      formats: i,
      parse: o,
      stringify: r
    };
  }, function (e, t, n) {
    var r = n(104),
        o = n(27),
        i = n(105),
        a = Function.prototype,
        c = Object.prototype,
        s = a.toString,
        u = c.hasOwnProperty,
        f = s.call(Object);

    e.exports = function (e) {
      if (!i(e) || "[object Object]" != r(e)) return !1;
      var t = o(e);
      if (null === t) return !0;
      var n = u.call(t, "constructor") && t.constructor;
      return "function" == typeof n && n instanceof n && s.call(n) == f;
    };
  }, function (e, t) {
    function n(e, t) {
      var n = [],
          r = [];
      return null == t && (t = function t(e, _t) {
        return n[0] === _t ? "[Circular ~]" : "[Circular ~." + r.slice(0, n.indexOf(_t)).join(".") + "]";
      }), function (o, i) {
        if (0 < n.length) {
          var a = n.indexOf(this);
          ~a ? n.splice(a + 1) : n.push(this), ~a ? r.splice(a, 1 / 0, o) : r.push(o), ~n.indexOf(i) && (i = t.call(this, o, i));
        } else n.push(i);

        return null == e ? i : e.call(this, o, i);
      };
    }

    (e.exports = function (e, t, r, o) {
      return JSON.stringify(e, n(t, o), r);
    }).getSerialize = n;
  }, function (e, t, n) {
    e.exports = n(106);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = new a(e),
          n = i(a.prototype.request, t);
      return o.extend(n, a.prototype, t), o.extend(n, t), n;
    }

    var o = n(1),
        i = n(11),
        a = n(37),
        c = n(18),
        s = r(n(14));
    s.Axios = a, s.create = function (e) {
      return r(c(s.defaults, e));
    }, s.Cancel = n(19), s.CancelToken = n(49), s.isCancel = n(13), s.all = function (e) {
      return Promise.all(e);
    }, s.spread = n(50), e.exports = s, e.exports.default = s;
  }, function (e) {
    e.exports = function (e) {
      return null != e && null != e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      this.defaults = e, this.interceptors = {
        request: new a(),
        response: new a()
      };
    }

    var o = n(1),
        i = n(12),
        a = n(38),
        c = n(39),
        s = n(18);
    r.prototype.request = function (e) {
      "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = s(this.defaults, e)).method = e.method ? e.method.toLowerCase() : "get";
      var t = [c, void 0],
          n = Promise.resolve(e);

      for (this.interceptors.request.forEach(function (e) {
        t.unshift(e.fulfilled, e.rejected);
      }), this.interceptors.response.forEach(function (e) {
        t.push(e.fulfilled, e.rejected);
      }); t.length;) {
        n = n.then(t.shift(), t.shift());
      }

      return n;
    }, r.prototype.getUri = function (e) {
      return e = s(this.defaults, e), i(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
    }, o.forEach(["delete", "get", "head", "options"], function (e) {
      r.prototype[e] = function (t, n) {
        return this.request(o.merge(n || {}, {
          method: e,
          url: t
        }));
      };
    }), o.forEach(["post", "put", "patch"], function (e) {
      r.prototype[e] = function (t, n, r) {
        return this.request(o.merge(r || {}, {
          method: e,
          url: t,
          data: n
        }));
      };
    }), e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r() {
      this.handlers = [];
    }

    var o = n(1);
    r.prototype.use = function (e, t) {
      return this.handlers.push({
        fulfilled: e,
        rejected: t
      }), this.handlers.length - 1;
    }, r.prototype.eject = function (e) {
      this.handlers[e] && (this.handlers[e] = null);
    }, r.prototype.forEach = function (e) {
      o.forEach(this.handlers, function (t) {
        null !== t && e(t);
      });
    }, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      e.cancelToken && e.cancelToken.throwIfRequested();
    }

    var o = n(1),
        i = n(40),
        a = n(13),
        c = n(14),
        s = n(47),
        u = n(48);

    e.exports = function (e) {
      return r(e), e.baseURL && !s(e.url) && (e.url = u(e.baseURL, e.url)), e.headers = e.headers || {}, e.data = i(e.data, e.headers, e.transformRequest), e.headers = o.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers || {}), o.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
        delete e.headers[t];
      }), (e.adapter || c.adapter)(e).then(function (t) {
        return r(e), t.data = i(t.data, t.headers, e.transformResponse), t;
      }, function (t) {
        return a(t) || (r(e), t && t.response && (t.response.data = i(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1);

    e.exports = function (e, t, n) {
      return r.forEach(n, function (n) {
        e = n(e, t);
      }), e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1);

    e.exports = function (e, t) {
      r.forEach(e, function (n, r) {
        r !== t && r.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[r]);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(17);

    e.exports = function (e, t, n) {
      var o = n.config.validateStatus;
      !o || o(n.status) ? e(n) : t(r("Request failed with status code " + n.status, n.config, null, n.request, n));
    };
  }, function (e) {
    "use strict";

    e.exports = function (e, t, n, r, o) {
      return e.config = t, n && (e.code = n), e.request = r, e.response = o, e.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1),
        o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    e.exports = function (e) {
      var t,
          n,
          i,
          a = {};
      return e ? (r.forEach(e.split("\n"), function (e) {
        if (i = e.indexOf(":"), t = r.trim(e.substr(0, i)).toLowerCase(), n = r.trim(e.substr(i + 1)), t) {
          if (a[t] && 0 <= o.indexOf(t)) return;
          a[t] = "set-cookie" === t ? (a[t] ? a[t] : []).concat([n]) : a[t] ? a[t] + ", " + n : n;
        }
      }), a) : a;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1);
    e.exports = r.isStandardBrowserEnv() ? function () {
      function e(e) {
        var t = e;
        return n && (o.setAttribute("href", t), t = o.href), o.setAttribute("href", t), {
          href: o.href,
          protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
          host: o.host,
          search: o.search ? o.search.replace(/^\?/, "") : "",
          hash: o.hash ? o.hash.replace(/^#/, "") : "",
          hostname: o.hostname,
          port: o.port,
          pathname: "/" === o.pathname.charAt(0) ? o.pathname : "/" + o.pathname
        };
      }

      var t,
          n = /(msie|trident)/i.test(navigator.userAgent),
          o = document.createElement("a");
      return t = e(window.location.href), function (n) {
        var o = r.isString(n) ? e(n) : n;
        return o.protocol === t.protocol && o.host === t.host;
      };
    }() : function () {
      return !0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1);
    e.exports = r.isStandardBrowserEnv() ? {
      write: function write(e, t, n, o, i, a) {
        var c = [];
        c.push(e + "=" + encodeURIComponent(t)), r.isNumber(n) && c.push("expires=" + new Date(n).toGMTString()), r.isString(o) && c.push("path=" + o), r.isString(i) && c.push("domain=" + i), !0 === a && c.push("secure"), document.cookie = c.join("; ");
      },
      read: function read(e) {
        var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return t ? decodeURIComponent(t[3]) : null;
      },
      remove: function remove(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (e) {
    "use strict";

    e.exports = function (e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    };
  }, function (e) {
    "use strict";

    e.exports = function (e, t) {
      return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if ("function" != typeof e) throw new TypeError("executor must be a function.");
      var t;
      this.promise = new Promise(function (e) {
        t = e;
      });
      var n = this;
      e(function (e) {
        n.reason || (n.reason = new o(e), t(n.reason));
      });
    }

    var o = n(19);
    r.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, r.source = function () {
      var e;
      return {
        token: new r(function (t) {
          e = t;
        }),
        cancel: e
      };
    }, e.exports = r;
  }, function (e) {
    "use strict";

    e.exports = function (e) {
      return function (t) {
        return e.apply(null, t);
      };
    };
  }, function (e, t, n) {
    var r = n(52),
        o = n(78),
        i = n(23),
        a = n(80),
        c = n(81),
        s = n(83),
        u = n(85),
        f = n(86),
        l = n(88),
        p = n(90),
        d = n(91),
        h = n(92),
        y = n(93),
        v = n(94),
        m = n(95),
        g = n(98),
        b = n(99),
        x = n(100),
        w = n(26),
        j = n(101),
        O = n(25),
        _ = 1,
        E = 2,
        P = 4,
        A = "[object Arguments]",
        S = "[object Function]",
        T = "[object GeneratorFunction]",
        k = "[object Object]",
        L = {};
    L[A] = L["[object Array]"] = L["[object ArrayBuffer]"] = L["[object DataView]"] = L["[object Boolean]"] = L["[object Date]"] = L["[object Float32Array]"] = L["[object Float64Array]"] = L["[object Int8Array]"] = L["[object Int16Array]"] = L["[object Int32Array]"] = L["[object Map]"] = L["[object Number]"] = L[k] = L["[object RegExp]"] = L["[object Set]"] = L["[object String]"] = L["[object Symbol]"] = L["[object Uint8Array]"] = L["[object Uint8ClampedArray]"] = L["[object Uint16Array]"] = L["[object Uint32Array]"] = !0, L["[object Error]"] = L[S] = L["[object WeakMap]"] = !1, e.exports = function e(t, n, C, U, N, R) {
      var D,
          B = n & _,
          z = n & E;
      if (C && (D = N ? C(t, U, N, R) : C(t)), void 0 !== D) return D;
      if (!w(t)) return t;
      var q = g(t);

      if (q) {
        if (D = y(t), !B) return u(t, D);
      } else {
        var F = h(t),
            H = F == S || F == T;
        if (b(t)) return s(t, B);

        if (F == k || F == A || H && !N) {
          if (D = z || H ? {} : m(t), !B) return z ? l(t, c(D, t)) : f(t, a(D, t));
        } else {
          if (!L[F]) return N ? t : {};
          D = v(t, F, B);
        }
      }

      R || (R = new r());
      var M = R.get(t);
      if (M) return M;
      if (R.set(t, D), j(t)) return t.forEach(function (r) {
        D.add(e(r, n, C, r, t, R));
      }), D;
      if (x(t)) return t.forEach(function (r, o) {
        D.set(o, e(r, n, C, o, t, R));
      }), D;
      var I = n & P ? z ? d : p : z ? keysIn : O,
          Q = q ? void 0 : I(t);
      return o(Q || t, function (r, o) {
        Q && (r = t[o = r]), i(D, o, e(r, n, C, o, t, R));
      }), D;
    };
  }, function (e, t, n) {
    function r(e) {
      var t = this.__data__ = new o(e);
      this.size = t.size;
    }

    var o = n(3),
        i = n(58),
        a = n(59),
        c = n(60),
        s = n(61),
        u = n(62);
    r.prototype.clear = i, r.prototype.delete = a, r.prototype.get = c, r.prototype.has = s, r.prototype.set = u, e.exports = r;
  }, function (e) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, n) {
    var r = n(4),
        o = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          n = r(t, e);
      return !(0 > n) && (n == t.length - 1 ? t.pop() : o.call(t, n, 1), --this.size, !0);
    };
  }, function (e, t, n) {
    var r = n(4);

    e.exports = function (e) {
      var t = this.__data__,
          n = r(t, e);
      return 0 > n ? void 0 : t[n][1];
    };
  }, function (e, t, n) {
    var r = n(4);

    e.exports = function (e) {
      return -1 < r(this.__data__, e);
    };
  }, function (e, t, n) {
    var r = n(4);

    e.exports = function (e, t) {
      var n = this.__data__,
          o = r(n, e);
      return 0 > o ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
    };
  }, function (e, t, n) {
    var r = n(3);

    e.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (e) {
    e.exports = function (e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    };
  }, function (e) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, n) {
    var r = n(3),
        o = n(21),
        i = n(65);

    e.exports = function (e, t) {
      var n = this.__data__;

      if (n instanceof r) {
        var a = n.__data__;
        if (!o || a.length < 199) return a.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new i(a);
      }

      return n.set(e, t), this.size = n.size, this;
    };
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(64));
  }, function (e) {
    var t = function () {
      return this;
    }();

    try {
      t = t || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (t = window);
    }

    e.exports = t;
  }, function (e, t, n) {
    function r(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    var o = n(66),
        i = n(73),
        a = n(75),
        c = n(76),
        s = n(77);
    r.prototype.clear = o, r.prototype.delete = i, r.prototype.get = a, r.prototype.has = c, r.prototype.set = s, e.exports = r;
  }, function (e, t, n) {
    var r = n(67),
        o = n(3),
        i = n(21);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (i || o)(),
        string: new r()
      };
    };
  }, function (e, t, n) {
    function r(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    var o = n(68),
        i = n(69),
        a = n(70),
        c = n(71),
        s = n(72);
    r.prototype.clear = o, r.prototype.delete = i, r.prototype.get = a, r.prototype.has = c, r.prototype.set = s, e.exports = r;
  }, function (e, t, n) {
    var r = n(5);

    e.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (e) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, n) {
    var r = n(5),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (r) {
        var n = t[e];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }

      return o.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, n) {
    var r = n(5),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return r ? void 0 !== t[e] : o.call(t, e);
    };
  }, function (e, t, n) {
    var r = n(5);

    e.exports = function (e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
  }, function (e, t, n) {
    var r = n(6);

    e.exports = function (e) {
      var t = r(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, n) {
    var r = n(6);

    e.exports = function (e) {
      return r(this, e).get(e);
    };
  }, function (e, t, n) {
    var r = n(6);

    e.exports = function (e) {
      return r(this, e).has(e);
    };
  }, function (e, t, n) {
    var r = n(6);

    e.exports = function (e, t) {
      var n = r(this, e),
          o = n.size;
      return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
    };
  }, function (e) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
        ;
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(8),
        o = function () {
      try {
        var e = r(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    e.exports = o;
  }, function (e, t, n) {
    var r = n(7),
        o = n(25);

    e.exports = function (e, t) {
      return e && r(t, o(t), e);
    };
  }, function (e, t, n) {
    var r = n(7),
        o = n(82);

    e.exports = function (e, t) {
      return e && r(t, o(t), e);
    };
  }, function (e) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var n in Object(e)) {
        t.push(n);
      }
      return t;
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(22),
          o = t && !t.nodeType && t,
          i = o && "object" == typeof e && e && !e.nodeType && e,
          a = i && i.exports === o ? r.Buffer : void 0,
          c = a ? a.allocUnsafe : void 0;

      e.exports = function (e, t) {
        if (t) return e.slice();
        var n = e.length,
            r = c ? c(n) : new e.constructor(n);
        return e.copy(r), r;
      };
    }).call(this, n(84)(e));
  }, function (e) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], !e.children && (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e) {
    e.exports = function (e, t) {
      var n = -1,
          r = e.length;

      for (t || (t = Array(r)); ++n < r;) {
        t[n] = e[n];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(7),
        o = n(87);

    e.exports = function (e, t) {
      return r(e, o(e), t);
    };
  }, function (e) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, n) {
    var r = n(7),
        o = n(89);

    e.exports = function (e, t) {
      return r(e, o(e), t);
    };
  }, function (e) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, n) {
    var r = n(9)(Object.keys, Object);
    e.exports = r;
  }, function (e) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var n in Object(e)) {
        t.push(n);
      }
      return t;
    };
  }, function (e) {
    var t = Object.prototype.toString;

    e.exports = function (e) {
      return t.call(e);
    };
  }, function (e) {
    var t = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var n = e.length,
          r = new e.constructor(n);
      return n && "string" == typeof e[0] && t.call(e, "index") && (r.index = e.index, r.input = e.input), r;
    };
  }, function (e) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, n) {
    var r = n(96),
        o = n(27),
        i = n(97);

    e.exports = function (e) {
      return "function" != typeof e.constructor || i(e) ? {} : r(o(e));
    };
  }, function (e, t, n) {
    var r = n(26),
        o = Object.create,
        i = function () {
      function e() {}

      return function (t) {
        if (!r(t)) return {};
        if (o) return o(t);
        e.prototype = t;
        var n = new e();
        return e.prototype = void 0, n;
      };
    }();

    e.exports = i;
  }, function (e) {
    e.exports = function () {
      return !1;
    };
  }, function (e) {
    var t = Array.isArray;
    e.exports = t;
  }, function (e) {
    e.exports = function () {
      return !1;
    };
  }, function (e) {
    e.exports = function () {
      return !1;
    };
  }, function (e) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(29),
        i = Object.prototype.hasOwnProperty,
        a = {
      brackets: function brackets(e) {
        return e + "[]";
      },
      comma: "comma",
      indices: function indices(e, t) {
        return e + "[" + t + "]";
      },
      repeat: function repeat(e) {
        return e;
      }
    },
        c = Array.isArray,
        s = Array.prototype.push,
        u = function u(e, t) {
      s.apply(e, c(t) ? t : [t]);
    },
        f = Date.prototype.toISOString,
        l = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: r.encode,
      encodeValuesOnly: !1,
      formatter: o.formatters[o.default],
      indices: !1,
      serializeDate: function serializeDate(e) {
        return f.call(e);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
        p = function e(t, n, o, i, a, s, f, p, d, h, y, v, m) {
      var g = t;

      if ("function" == typeof f ? g = f(n, g) : g instanceof Date ? g = h(g) : "comma" === o && c(g) && (g = g.join(",")), null === g) {
        if (i) return s && !v ? s(n, l.encoder, m) : n;
        g = "";
      }

      if ("string" == typeof g || "number" == typeof g || "boolean" == typeof g || r.isBuffer(g)) return s ? [y(v ? n : s(n, l.encoder, m)) + "=" + y(s(g, l.encoder, m))] : [y(n) + "=" + y(g + "")];
      var b,
          x = [];
      if (void 0 === g) return x;
      if (c(f)) b = f;else {
        var w = Object.keys(g);
        b = p ? w.sort(p) : w;
      }

      for (var j, O = 0; O < b.length; ++O) {
        j = b[O], (!a || null !== g[j]) && (c(g) ? u(x, e(g[j], "function" == typeof o ? o(n, j) : n, o, i, a, s, f, p, d, h, y, v, m)) : u(x, e(g[j], n + (d ? "." + j : "[" + j + "]"), o, i, a, s, f, p, d, h, y, v, m)));
      }

      return x;
    },
        d = function d(e) {
      if (!e) return l;
      if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
      var t = e.charset || l.charset;
      if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      var n = o.default;

      if (void 0 !== e.format) {
        if (!i.call(o.formatters, e.format)) throw new TypeError("Unknown format option provided.");
        n = e.format;
      }

      var r = o.formatters[n],
          a = l.filter;
      return ("function" == typeof e.filter || c(e.filter)) && (a = e.filter), {
        addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : l.addQueryPrefix,
        allowDots: void 0 === e.allowDots ? l.allowDots : !!e.allowDots,
        charset: t,
        charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : l.charsetSentinel,
        delimiter: void 0 === e.delimiter ? l.delimiter : e.delimiter,
        encode: "boolean" == typeof e.encode ? e.encode : l.encode,
        encoder: "function" == typeof e.encoder ? e.encoder : l.encoder,
        encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : l.encodeValuesOnly,
        filter: a,
        formatter: r,
        serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : l.serializeDate,
        skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : l.skipNulls,
        sort: "function" == typeof e.sort ? e.sort : null,
        strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : l.strictNullHandling
      };
    };

    e.exports = function (e, t) {
      var n,
          r = e,
          o = d(t);
      "function" == typeof o.filter ? r = (0, o.filter)("", r) : c(o.filter) && (n = o.filter);
      var i = [];
      if ("object" != typeof r || null === r) return "";
      var s = t && t.arrayFormat in a ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices",
          f = a[s];
      n || (n = Object.keys(r)), o.sort && n.sort(o.sort);

      for (var l, h = 0; h < n.length; ++h) {
        l = n[h], (!o.skipNulls || null !== r[l]) && u(i, p(r[l], l, f, o.strictNullHandling, o.skipNulls, o.encode ? o.encoder : null, o.filter, o.sort, o.allowDots, o.serializeDate, o.formatter, o.encodeValuesOnly, o.charset));
      }

      var y = i.join(o.delimiter),
          v = !0 === o.addQueryPrefix ? "?" : "";
      return o.charsetSentinel && ("iso-8859-1" === o.charset ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), 0 < y.length ? v + y : "";
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = Object.prototype.hasOwnProperty,
        i = {
      allowDots: !1,
      allowPrototypes: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decoder: r.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
        a = function a(e) {
      return e.replace(/&#(\d+);/g, function (e, t) {
        return String.fromCharCode(parseInt(t, 10));
      });
    },
        c = function c(e, t) {
      var n,
          c = {},
          s = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
          u = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
          f = s.split(t.delimiter, u),
          l = -1,
          p = t.charset;
      if (t.charsetSentinel) for (n = 0; n < f.length; ++n) {
        0 === f[n].indexOf("utf8=") && ("utf8=%E2%9C%93" === f[n] ? p = "utf-8" : "utf8=%26%2310003%3B" === f[n] && (p = "iso-8859-1"), l = n, n = f.length);
      }

      for (n = 0; n < f.length; ++n) {
        if (n !== l) {
          var d,
              h,
              y = f[n],
              v = y.indexOf("]="),
              m = -1 === v ? y.indexOf("=") : v + 1;
          -1 === m ? (d = t.decoder(y, i.decoder, p), h = t.strictNullHandling ? null : "") : (d = t.decoder(y.slice(0, m), i.decoder, p), h = t.decoder(y.slice(m + 1), i.decoder, p)), h && t.interpretNumericEntities && "iso-8859-1" === p && (h = a(h)), h && t.comma && -1 < h.indexOf(",") && (h = h.split(",")), c[d] = o.call(c, d) ? r.combine(c[d], h) : h;
        }
      }

      return c;
    },
        s = function s(e, t, n) {
      if (e) {
        var r = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            i = /(\[[^[\]]*])/g,
            a = /(\[[^[\]]*])/.exec(r),
            c = a ? r.slice(0, a.index) : r,
            s = [];

        if (c) {
          if (!n.plainObjects && o.call(Object.prototype, c) && !n.allowPrototypes) return;
          s.push(c);
        }

        for (var u = 0; null !== (a = i.exec(r)) && u < n.depth;) {
          if (u += 1, !n.plainObjects && o.call(Object.prototype, a[1].slice(1, -1)) && !n.allowPrototypes) return;
          s.push(a[1]);
        }

        return a && s.push("[" + r.slice(a.index) + "]"), function (e, t, n) {
          for (var r = t, o = e.length - 1; 0 <= o; --o) {
            var i,
                a = e[o];
            if ("[]" === a && n.parseArrays) i = [].concat(r);else {
              i = n.plainObjects ? Object.create(null) : {};
              var c = "[" === a.charAt(0) && "]" === a.charAt(a.length - 1) ? a.slice(1, -1) : a,
                  s = parseInt(c, 10);
              n.parseArrays || "" !== c ? !isNaN(s) && a !== c && s + "" === c && 0 <= s && n.parseArrays && s <= n.arrayLimit ? (i = [])[s] = r : i[c] = r : i = {
                0: r
              };
            }
            r = i;
          }

          return r;
        }(s, t, n);
      }
    },
        u = function u(e) {
      if (!e) return i;
      if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
      if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
      var t = void 0 === e.charset ? i.charset : e.charset;
      return {
        allowDots: void 0 === e.allowDots ? i.allowDots : !!e.allowDots,
        allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : i.allowPrototypes,
        arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : i.arrayLimit,
        charset: t,
        charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : i.charsetSentinel,
        comma: "boolean" == typeof e.comma ? e.comma : i.comma,
        decoder: "function" == typeof e.decoder ? e.decoder : i.decoder,
        delimiter: "string" == typeof e.delimiter || r.isRegExp(e.delimiter) ? e.delimiter : i.delimiter,
        depth: "number" == typeof e.depth ? e.depth : i.depth,
        ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
        interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : i.interpretNumericEntities,
        parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : i.parameterLimit,
        parseArrays: !1 !== e.parseArrays,
        plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : i.plainObjects,
        strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : i.strictNullHandling
      };
    };

    e.exports = function (e, t) {
      var n = u(t);
      if ("" === e || null == e) return n.plainObjects ? Object.create(null) : {};

      for (var o = "string" == typeof e ? c(e, n) : e, i = n.plainObjects ? Object.create(null) : {}, a = Object.keys(o), f = 0; f < a.length; ++f) {
        var l = a[f],
            p = s(l, o[l], n);
        i = r.merge(i, p, n);
      }

      return r.compact(i);
    };
  }, function (e) {
    var t = Object.prototype.toString;

    e.exports = function (e) {
      return t.call(e);
    };
  }, function (e) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null == arguments[t] ? {} : arguments[t],
            r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function (t) {
          i(e, t, n[t]);
        });
      }

      return e;
    }

    function i(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function a(e, t) {
      var n = o({}, {
        insecure: !1,
        retryOnError: !0,
        logHandler: function logHandler(e, t) {
          if ("error" === e && t) {
            var n = [t.name, t.message].filter(function (e) {
              return e;
            }).join(" - ");
            return console.error("[error] ".concat(n)), void console.error(t);
          }

          console.log("[".concat(e, "] ").concat(t));
        },
        headers: {},
        httpAgent: !1,
        httpsAgent: !1,
        timeout: 3e4,
        proxy: !1,
        basePath: "",
        adapter: !1
      }, t);

      if (!n.accessToken) {
        var i = new TypeError("Expected parameter accessToken");
        throw n.logHandler("error", i), i;
      }

      var c = n.insecure ? "http" : "https",
          s = n.space ? "".concat(n.space, "/") : "",
          u = n.defaultHostname,
          f = n.insecure ? 80 : 443;

      if (M.test(n.host)) {
        var l = n.host.split(":");

        if (2 === l.length) {
          var p = r(l, 2);
          u = p[0], f = p[1];
        } else u = l[0];
      }

      n.basePath && (n.basePath = "/".concat(n.basePath.split("/").filter(Boolean).join("/")));
      var d = t.baseURL || "".concat(c, "://").concat(u, ":").concat(f).concat(n.basePath, "/spaces/").concat(s);
      n.headers.Authorization || (n.headers.Authorization = "Bearer " + n.accessToken), Object(H.b)() && (n.headers["user-agent"] = "node.js/" + Object(H.a)(), n.headers["Accept-Encoding"] = "gzip");
      var h = {
        baseURL: d,
        headers: n.headers,
        httpAgent: n.httpAgent,
        httpsAgent: n.httpsAgent,
        paramsSerializer: B.a.stringify,
        proxy: n.proxy,
        timeout: n.timeout,
        adapter: n.adapter,
        logHandler: n.logHandler,
        responseLogger: n.responseLogger,
        requestLogger: n.requestLogger,
        retryOnError: n.retryOnError
      },
          y = e.create(h);
      return y.httpClientParams = t, y.cloneWithNewParams = function (n) {
        return a(e, o({}, R()(t), n));
      }, function (e, t) {
        var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 5;
        z.set(e, t);
        var r = z.get(e),
            o = r.responseLogger,
            i = void 0 === o ? function () {} : o,
            a = r.requestLogger,
            c = void 0 === a ? function () {} : a;
        e.interceptors.request.use(function (e) {
          return c(e), e;
        }, function (e) {
          return Promise.reject(e);
        }), e.interceptors.response.use(function (e) {
          return F = 0, i(e), e;
        }, function (t) {
          var o = Math.pow,
              i = t.response,
              a = t.config;
          if (!a || !r.retryOnError) return Promise.reject(t);
          var c = null,
              s = 0;
          if (i) q = 0;else {
            if (c = "Connection", ++q > n) return t.attempts = q, Promise.reject(t);
            s = o(Math.SQRT2, q), i = {};
          }
          return 500 <= i.status && 600 > i.status ? (c = "Server ".concat(i.status), F++, s = o(Math.SQRT2, F)) : 429 === i.status && (c = "Rate limit", F++, i.headers && t.response.headers["x-contentful-ratelimit-reset"] && (s = i.headers["x-contentful-ratelimit-reset"])), F > n ? (t.attempts = F, Promise.reject(t)) : c ? (s = Math.floor(1e3 * s + 200 * Math.random() + 500), r.logHandler("warning", "".concat(c, " error occurred. Waiting for ").concat(s, " ms before retrying...")), delete a.httpAgent, delete a.httpsAgent, function (e) {
            return new Promise(function (t) {
              setTimeout(t, e);
            });
          }(s).then(function () {
            return e(a);
          })) : Promise.reject(t);
        });
      }(y, h), y;
    }

    function c(e) {
      var t = e.query,
          n = {};
      return delete t.resolveLinks, n.params = R()(t), n;
    }

    function s(e) {
      return function e(t) {
        return Object.keys(t).forEach(function (n) {
          var r = t[n];
          Q()(r) && e(r);
        }), Object.freeze(t);
      }(e.sys || {}), e;
    }

    function u() {
      if (!window) return null;
      var e = window.navigator.userAgent,
          t = window.navigator.platform,
          n = null;
      return -1 === ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(t) ? -1 === ["iPhone", "iPad", "iPod"].indexOf(t) ? -1 === ["Win32", "Win64", "Windows", "WinCE"].indexOf(t) ? /Android/.test(e) ? n = "Android" : /Linux/.test(t) && (n = "Linux") : n = "Windows" : n = "iOS" : n = "macOS", n;
    }

    function f(e, t, n, r) {
      var o = [];
      t && o.push("app ".concat(t)), n && o.push("integration ".concat(n)), r && o.push("feature " + r), o.push("sdk ".concat(e));
      var i = null;

      try {
        "undefined" != typeof window && "navigator" in window && "product" in window.navigator && "ReactNative" === window.navigator.product ? (i = u(), o.push("platform ReactNative")) : Object(H.b)() ? (i = function () {
          var e = Object(V.platform)() || "linux",
              t = Object(V.release)() || "0.0.0",
              n = {
            android: "Android",
            aix: "Linux",
            darwin: "macOS",
            freebsd: "Linux",
            linux: "Linux",
            openbsd: "Linux",
            sunos: "Linux",
            win32: "Windows"
          };
          return e in n ? "".concat(n[e] || "Linux", "/").concat(t) : null;
        }(), o.push("platform node.js/".concat(Object(H.a)()))) : (i = u(), o.push("platform browser"));
      } catch (t) {
        i = null;
      }

      return i && o.push("os ".concat(i)), "".concat(o.filter(function (e) {
        return "" !== e;
      }).join("; "), ";");
    }

    function l(e) {
      return Object.defineProperty(e, "toPlainObject", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: function value() {
          return R()(this);
        }
      });
    }

    function p(e) {
      return s(l(e));
    }

    function d(e) {
      return Object.defineProperty(e, "stringifySafe", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: function value() {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : null,
              t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "";
          return X()(this, e, t, function (e, t) {
            return {
              sys: {
                type: "Link",
                linkType: "Entry",
                id: t.sys.id,
                circular: !0
              }
            };
          });
        }
      });
    }

    function h(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }

    function y(e) {
      return s(l(R()(e)));
    }

    function v(e, t) {
      var n = t.resolveLinks,
          r = t.removeUnresolved,
          o = d(l(R()(e)));
      return n && (o.items = Z(o, {
        removeUnresolved: r,
        itemEntryPoints: ["fields"]
      })), s(o);
    }

    function m(e) {
      return s(l(R()(e)));
    }

    function g(e) {
      return s(l(R()(e)));
    }

    function b(e) {
      return s(l(R()(e)));
    }

    function x(e) {
      return s(l(R()(e)));
    }

    function w(e) {
      return s(l(R()(e)));
    }

    function j(e) {
      return s(l(R()(e)));
    }

    function O(e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
      if (!t || !t.initial && !t.nextSyncToken && !t.nextPageToken) throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
      if (t && t.content_type && !t.type) t.type = "Entry";else if (t && t.content_type && t.type && "Entry" !== t.type) throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
      var r = te({}, {
        resolveLinks: !0,
        removeUnresolved: !1,
        paginate: !0
      }, n),
          o = r.resolveLinks,
          i = r.removeUnresolved;
      return function e(t, n, r, o) {
        var i = o.paginate;
        return r.nextSyncToken && (r.sync_token = r.nextSyncToken, delete r.nextSyncToken), r.nextPageToken && (r.sync_token = r.nextPageToken, delete r.nextPageToken), r.sync_token && (delete r.initial, delete r.type, delete r.content_type), t.get("sync", c({
          query: r
        })).then(function (o) {
          var a = o.data;
          return n = n.concat(a.items), a.nextPageUrl ? i ? (delete r.initial, r.sync_token = _(a.nextPageUrl), e(t, n, r, {
            paginate: i
          })) : {
            items: n,
            nextPageToken: _(a.nextPageUrl)
          } : a.nextSyncUrl ? {
            items: n,
            nextSyncToken: _(a.nextSyncUrl)
          } : void 0;
        });
      }(e, [], t, {
        paginate: r.paginate
      }).then(function (e) {
        o && (e.items = Z(e, {
          removeUnresolved: i,
          itemEntryPoints: ["fields"]
        }));

        var t = function (e) {
          var t = function t(e) {
            return function (t, n) {
              return n.sys.type === e && t.push(l(n)), t;
            };
          };

          return {
            entries: e.reduce(t("Entry"), []),
            assets: e.reduce(t("Asset"), []),
            deletedEntries: e.reduce(t("DeletedEntry"), []),
            deletedAssets: e.reduce(t("DeletedAsset"), [])
          };
        }(e.items);

        return e.nextSyncToken && (t.nextSyncToken = e.nextSyncToken), e.nextPageToken && (t.nextPageToken = e.nextPageToken), s(d(l(t)));
      }, function (e) {
        throw e;
      });
    }

    function _(e) {
      var t = e.split("?");
      return 0 < t.length ? t[1].replace("sync_token=", "") : "";
    }

    function E(e) {
      function t(e) {
        if (e.data) throw e.data;
        throw e;
      }

      function n(e) {
        e.select && !/sys/i.test(e.select) && (e.select += ",sys");
      }

      function r(e) {
        e.defaults.baseURL = i().environmentBaseUrl;
      }

      var o = e.http,
          i = e.getGlobalOptions,
          a = ee.space.wrapSpace,
          s = ee.contentType,
          u = s.wrapContentType,
          f = s.wrapContentTypeCollection,
          l = ee.entry,
          p = l.wrapEntry,
          d = l.wrapEntryCollection,
          h = ee.asset,
          y = h.wrapAsset,
          v = h.wrapAssetCollection,
          m = ee.locale.wrapLocaleCollection;
      return {
        getSpace: function getSpace() {
          return o.defaults.baseURL = i().spaceBaseUrl, o.get("").then(function (e) {
            return a(e.data);
          }, t);
        },
        getContentType: function getContentType(e) {
          return r(o), o.get("content_types/" + e).then(function (e) {
            return u(e.data);
          }, t);
        },
        getContentTypes: function getContentTypes() {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
          return r(o), o.get("content_types", c({
            query: e
          })).then(function (e) {
            return f(e.data);
          }, t);
        },
        getEntry: function getEntry(e) {
          var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
          return this.getEntries(ne({
            "sys.id": e
          }, n)).then(function (t) {
            if (0 < t.items.length) return p(t.items[0]);
            throw function (e) {
              var t = new Error("The resource could not be found.");
              return t.sys = {
                type: "Error",
                id: "NotFound"
              }, t.details = {
                type: "Entry",
                id: e,
                environment: i().environment,
                space: i().space
              }, t;
            }(e);
          }, t);
        },
        getEntries: function getEntries() {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
          r(o);
          var a = i(e),
              s = a.resolveLinks,
              u = a.removeUnresolved;
          return n(e), o.get("entries", c({
            query: e
          })).then(function (e) {
            return d(e.data, {
              resolveLinks: s,
              removeUnresolved: u
            });
          }, t);
        },
        getAsset: function getAsset(e) {
          var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
          return r(o), n(i), o.get("assets/" + e, c({
            query: i
          })).then(function (e) {
            return y(e.data);
          }, t);
        },
        getAssets: function getAssets() {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
          return r(o), n(e), o.get("assets", c({
            query: e
          })).then(function (e) {
            return v(e.data);
          }, t);
        },
        getLocales: function getLocales() {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
          return r(o), o.get("locales", c({
            query: e
          })).then(function (e) {
            return m(e.data);
          }, t);
        },
        parseEntries: function parseEntries(e) {
          var t = i({}),
              n = t.resolveLinks,
              r = t.removeUnresolved;
          return d(e, {
            resolveLinks: n,
            removeUnresolved: r
          });
        },
        sync: function sync() {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
              t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {
            paginate: !0
          },
              n = i(e),
              a = n.resolveLinks,
              c = n.removeUnresolved;
          return r(o), O(o, e, ne({
            resolveLinks: a,
            removeUnresolved: c
          }, t));
        }
      };
    }

    function P(e) {
      if (!e.accessToken) throw new TypeError("Expected parameter accessToken");
      if (!e.space) throw new TypeError("Expected parameter space");
      var t = re({}, {
        resolveLinks: !0,
        removeUnresolved: !1,
        defaultHostname: "cdn.contentful.com",
        environment: "master"
      }, e),
          n = f("contentful.js/0.0.0-determined-by-semantic-release", t.application, t.integration);
      t.headers = re({}, t.headers, {
        "Content-Type": "application/vnd.contentful.delivery.v1+json",
        "X-Contentful-User-Agent": n
      });

      var r = a(U.a, t),
          o = function (e) {
        return function (t) {
          return Object.assign({}, e, t);
        };
      }({
        resolveLinks: t.resolveLinks,
        environment: t.environment,
        removeUnresolved: t.removeUnresolved,
        spaceBaseUrl: r.defaults.baseURL,
        environmentBaseUrl: r.defaults.baseURL + "environments/" + t.environment
      });

      return r.defaults.baseURL = o().environmentBaseUrl, E({
        http: r,
        getGlobalOptions: o
      });
    }

    n.r(t);
    var A = {};
    n.r(A), n.d(A, "wrapSpace", function () {
      return p;
    });
    var S = {};
    n.r(S), n.d(S, "wrapEntry", function () {
      return y;
    }), n.d(S, "wrapEntryCollection", function () {
      return v;
    });
    var T = {};
    n.r(T), n.d(T, "wrapAsset", function () {
      return m;
    }), n.d(T, "wrapAssetCollection", function () {
      return g;
    });
    var k = {};
    n.r(k), n.d(k, "wrapContentType", function () {
      return b;
    }), n.d(k, "wrapContentTypeCollection", function () {
      return x;
    });
    var L = {};
    n.r(L), n.d(L, "wrapLocale", function () {
      return w;
    }), n.d(L, "wrapLocaleCollection", function () {
      return j;
    });

    var C = n(30),
        U = n.n(C),
        N = n(0),
        R = n.n(N),
        D = n(31),
        B = n.n(D),
        z = new Map(),
        q = 0,
        F = 0,
        H = n(2),
        M = /^(?!\w+:\/\/)([^\s:]+\.[^\s:]+)(?::(\d+))?(?!:)$/,
        I = n(32),
        Q = n.n(I),
        V = n(10),
        W = n(33),
        X = n.n(W),
        $ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        J = {},
        G = function G(e) {
      return e && e.sys && "Link" === e.sys.type;
    },
        K = function K(e, t) {
      var n = t.sys,
          r = n.linkType,
          o = n.id;
      return function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) {
          if (t(e[n])) return e[n];
        }

        return J;
      }(e, function (e) {
        var t = e.sys;
        return t.type === r && t.id === o;
      });
    },
        Y = function e(t, n, r, o) {
      if (n(t)) return r(t);

      if (t && "object" === (void 0 === t ? "undefined" : $(t))) {
        for (var i in t) {
          t.hasOwnProperty(i) && (t[i] = e(t[i], n, r, o));
        }

        o && (t = function (e) {
          if (Array.isArray(e)) return e.filter(function (e) {
            return e !== J;
          });

          for (var t in e) {
            e[t] === J && delete e[t];
          }

          return e;
        }(t));
      }

      return t;
    },
        Z = function Z(e, t) {
      if (t = t || {}, !e.items) return [];
      var n = R()(e),
          r = Object.keys(n.includes || {}).reduce(function (t, n) {
        return [].concat(h(t), h(e.includes[n]));
      }, []),
          o = [].concat(h(n.items), h(r));
      return o.forEach(function (e) {
        var n = function (e, t) {
          return Array.isArray(t) ? Object.keys(e).filter(function (e) {
            return -1 !== t.indexOf(e);
          }).reduce(function (t, n) {
            return t[n] = e[n], t;
          }, {}) : e;
        }(e, t.itemEntryPoints);

        Object.assign(e, Y(n, G, function (e) {
          return function (e, t, n) {
            var r = K(e, t);
            return r === J ? n ? r : t : r;
          }(o, e, t.removeUnresolved);
        }, t.removeUnresolved));
      }), n.items;
    },
        ee = {
      space: A,
      entry: S,
      asset: T,
      contentType: k,
      locale: L
    },
        te = Object.assign || function (e) {
      for (var t, n = 1; n < arguments.length; n++) {
        for (var r in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }

      return e;
    },
        ne = Object.assign || function (e) {
      for (var t, n = 1; n < arguments.length; n++) {
        for (var r in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }

      return e;
    };

    n.d(t, "createClient", function () {
      return P;
    });

    var re = Object.assign || function (e) {
      for (var t, n = 1; n < arguments.length; n++) {
        for (var r in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }

      return e;
    };
  }]);
});